const getRules = (t) => ({
    required: (value) =>
        (!value || value === '' || (Array.isArray(value) && value.length === 0)
            ? t("error.requiredField") || 'Required field'
            : null),
    email: (value) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(value) ? null : t('error.pattern') || 'Invalid email format';
    },
    tel: (value) => {
        const nordicPhoneRegex = /^(?:\+|00)?(3[0-9]|4[0-9])?\s?(\d\s?){6,12}$/;
        return nordicPhoneRegex.test(value) ? null : t("error.pattern") || 'Invalid phone number format';
    },
    pattern: (pattern, value) => {
        const regex = new RegExp(pattern);
        return regex.test(value) ? null : t("error.pattern") || 'Invalid format';
    },
    min: (min, value) =>
        Number(value) >= min ? null : `${t("error.min")} ${min}` || `Minimum is ${min}`,
    max: (max, value) =>
        Number(value) <= max ? null : `${t("error.max")} ${max}` || `Maximum is ${max}`,
    minLength: (min, value) =>
        value.length >= min ? null :`${t("error.minLength")} ${min}` || `Min length ${min}`,
    maxLength: (max, value) =>
        value.length <= max ? null : `${t("error.maxLength")} ${max}` || `Max length ${max}`,
    custom: (fn, value) => fn(value),

});

const createValidator = (t) => {
    const rules = getRules(t);
    return (props, value) => {
        let error = null;
        if (props.required) error = rules.required(value);
        if (!error && props.type === 'email') error = rules.email(value);
        if (!error && props.type === 'tel') error = rules.tel(value);
        if (!error && props.pattern) error = rules.pattern(props.pattern, value);
        if (!error && props.min) error = rules.min(props.min, value);
        if (!error && props.max) error = rules.max(props.max, value);
        if (!error && props.minLength) error = rules.minLength(props.minLength, value);
        if (!error && props.maxLength) error = rules.maxLength(props.maxLength, value);
        if (!error && props.customValidation) error = rules.custom(props.customValidation, value);
        return error;
    };
};

export default createValidator;
